import { PaymentSetupStepsProvider } from '@perpay-web/fintech/components/composite/PaymentSetup/usePaymentSetupStepsContext';
import { createCombinedProvider } from '@perpay-web/utils/componentUtils';

const StepsProviders = createCombinedProvider(PaymentSetupStepsProvider);

export default StepsProviders;
